/**
 * Pure utils for the Shippings form.
 * Matches backend ShippingCreate/ShippingUpdate fields.
 */

export const emptyFormData = () => ({
  product_supplier_id: null,
  ships_to_country: '',
  ships_to_region: '',
  lead_time_days: '',
  carrier: '',
  freight_type: '',
  freight_price: '',
  unit_of_price: ''
});

/**
 * Map API shipping to form data (for edit mode).
 * @param {Object} shipping - shipping from API (id, product_supplier_id, ships_to_country, ...)
 */
export const shippingToFormData = (shipping) => ({
  product_supplier_id: shipping.product_supplier_id ?? null,
  ships_to_country: shipping.ships_to_country ?? '',
  ships_to_region: shipping.ships_to_region ?? '',
  lead_time_days: shipping.lead_time_days != null ? shipping.lead_time_days : '',
  carrier: shipping.carrier ?? '',
  freight_type: shipping.freight_type ?? '',
  freight_price: shipping.freight_price != null ? shipping.freight_price : '',
  unit_of_price: shipping.unit_of_price ?? ''
});
